export const AvatarVariants = {
    EndCustomers: 'end-customers',
    ExternalContacts: 'external-contacts',
    InternalContacts: 'internal-directory',
    Agents: 'agents',
    Supervisor: 'supervisor',
    Queue: 'queue',
    Default: 'default',
} as const;

export type AvatarVariant = typeof AvatarVariants[keyof typeof AvatarVariants];
